module.exports = {
  category:    'connector',
  id:          'figma',
  name:        'Figma',
  enabled:     true,
  icon:        'F',
  iconBg:      '#1E1E1E',
  svgPath:     null,
  svgViewBox:  '0 0 38 57',
  svgPaths: [
    { fill: '#F24E1E', d: 'M9.5 0h9.5v19H9.5a9.5 9.5 0 1 1 0-19Z' },
    { fill: '#FF7262', d: 'M19 0h9.5a9.5 9.5 0 1 1 0 19H19V0Z' },
    { fill: '#A259FF', d: 'M9.5 19H19v19H9.5a9.5 9.5 0 1 1 0-19Z' },
    { fill: '#1ABCFE', d: 'M19 19h9.5a9.5 9.5 0 1 1-9.5 9.5V19Z' },
    { fill: '#0ACF83', d: 'M0 47.5A9.5 9.5 0 0 1 9.5 38H19v9.5a9.5 9.5 0 1 1-19 0Z' },
  ],

  tagline:     'Connect approved design files and libraries to Pabs.',
  description: 'Connect Figma so Pabs can securely read the design files and libraries you choose. Pabs will keep the selected source, version and approved guidance ready for product and design work.',
  useCases: [
    'Choose approved design files and libraries for product work',
    'Keep a versioned record of the components and patterns your team trusts',
    'Use the same design direction across Pabs and connected AI builders',
  ],
  accountGuidance: 'Pabs asks for read-only access. It never edits Figma files or publishes changes.',

  params: {
    type: 'object',
    properties: {
      operation: {
        type: 'string',
        enum: ['pull_design_context', 'push_strategy_to_figjam'],
        description: 'What to do with Figma',
      },
      plan_id: { type: 'integer' },
      figma_file_key: { type: 'string' },
    },
    required: ['operation', 'plan_id'],
  },
  result: {
    type: 'object',
    properties: {
      success: { type: 'boolean' },
    },
  },
  artifact: null,

  handler: async () => {
    throw new Error('Figma actions are available through the connected source flow.');
  },
};
